import { ParseBaseRepository } from '../../parse-base.repository';
import { AddMemberships, type IAddMembershipsHandler } from '@telespot/authentication/use-cases';
import { type WorkspaceRepository } from '@telespot/domain';

/**
 * Parse implementation of the {@link IAddMembershipsHandler} interface.
 *
 * @group Workspaces
 * @category Handlers
 */
export class AddMembershipsHandler extends ParseBaseRepository implements IAddMembershipsHandler {
  constructor(
    private readonly workspaceRepository: WorkspaceRepository,
    protected readonly parse: typeof Parse,
    protected readonly options: Parse.FullOptions = { useMasterKey: true }
  ) {
    super(parse, options);
  }

  public async execute(command: AddMemberships): Promise<{ workspaceId: string; membershipId: string }[]> {
    const { userId, workspaceIds, batchSize } = command.details;
    try {
      const existingMemberships = await this.workspaceRepository.searchUserMemberships(userId, workspaceIds);
      const newWorkspaceIds = workspaceIds.filter((id) => !existingMemberships.some((m) => m.workspaceId === id));
      const newMemberships = await this.workspaceRepository.createUserMemberships(userId, newWorkspaceIds, batchSize);
      return [...existingMemberships, ...newMemberships];
    } catch (error) {
      throw { type: 'UNKNOWN', message: error.message };
    }
  }
}
